<template>
  <div class="box-container p-2">
    <div class="flex justify-center">
      <img src="/img/survey_report_icon.svg" />
    </div>
    <p class="text-content">{{ content }}</p>
    <p class="text-title">{{ $t(title) }}</p>
  </div>
</template>

<script>
export default {
  props: ["content", "title"]
};
</script>
<style lang="scss" scoped>
.box-container {
  background: #ffffff;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12),
    0px 6px 10px rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  min-width: 150px;
  img {
    width: 27px !important;
  }
}
.text-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 15px;
  text-align: center;
  color: #3c4858;
}
.text-content {
  font-weight: 400;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  color: #2d82b5;
}
</style>
